module.exports = __webpack_public_path__ + "static/ship-globally-37b6c7d5bf3d02f4479281ffc20de52b.png";